module.exports = __webpack_public_path__ + "static/media/myJam-drag-and-drop.18d52538.png";